import React from 'react';
import Chip from '@material-ui/core/Chip';
import './Custom-Chip.scss';

const CustomChip = (props) => {
  const { label, color } = props;
  return (
    <div className='custom-chip'>
      <Chip label={label} color={color} />
    </div>
  );
};

export default CustomChip;
